var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-primary",class:{ 'is-loading': _vm.isLoading, 'is-fullwidth': !_vm.isInline }},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.isLoading)?_c('spinner',{staticClass:"animated fadeInLeft"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }